module.exports = __webpack_public_path__ + "img/25.babff5bf.jpg";